<template>
    <modal @close="closeModal">
        <h1 class="modal__title">
            <small>Download SSL certificaat</small>
        </h1>

        <div class="page-block__item">
        {{ subscription.domain }}
        </div>

        <div v-for="(link, key) in subscription.certificates" :key="key" class="page-block__item">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                        <span class="page-block__item-content-title">
                            {{ key }}
                        </span>
                    </div>
                    <div class="layout__item u-2/3-desk">
                        <a :href="link" class="btn btn--blue">
                            Download
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="page-block__item">
            <div class="modal__nav">
                <button
                    class="btn btn--ghost-gray btn-ghost--dns | u-margin-right"
                    type="button"
                    @click="closeModal"
                >
                    {{ trans('action.cancel') }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { apiMixin } from 'relapp-api';
import { Modal } from 'relapp-modal';
import { Way2Form } from 'relapp-way2forms';
import { ServicesApi } from 'relapp-technical-management';

export default {
    components: {
        Modal
    },
    mixins: [apiMixin],
    props: {
        subscription: {
            type: Object,
            default: null
        }
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        }
    }
};
</script>
